import { Row, Container, Col, size } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import React from 'react';
import { IPartnerSection } from 'utils/types';

import * as S from './styles';

export const PartnerSection: React.FC<IPartnerSection> = ({
  testId,
  title = '',
  headline,
  description,
  backgroundColor,
  slug,
  cta,
}) => (
  <SectionWrapper
    data-testid={testId}
    id={slug}
    backgroundColor={backgroundColor}
    style={{ padding: `0 0 ${size.lg}px 0` }}
  >
    <Container>
      {title ? (
        <Row center="xs">
          <Col md={10} xs={12}>
            <S.SectionTitle text={title} />
          </Col>
        </Row>
      ) : null}
      <Row center="xs">
        <Col md={10} xs={12}>
          <S.SectionHeadline>{headline}</S.SectionHeadline>
        </Col>
      </Row>
      {cta ? (
        <Row center="xs" around="lg">
          <Col md={10} xs={12}>
            <S.Button
              href={cta?.url}
              appearance="primary"
              $marginBottom={description ? size.xl1 : ''}
            >
              {cta?.text}
            </S.Button>
          </Col>
        </Row>
      ) : null}
      {description ? (
        <Row>
          <Col md={10} xs={12}>
            <S.Reference>{description}</S.Reference>
          </Col>
        </Row>
      ) : null}
    </Container>
  </SectionWrapper>
);

export default PartnerSection;
